export default "__VITE_ASSET__DQctSNxI__"